// @ts-nocheck
import React from 'react';
import { signInCodesQuery } from 'graphql/admin/sign-in-codes';
import { CopyIcon, TableContainer, ListView } from 'routes/admin/style';
import ApiList from 'components/grid/api-list';
import Table from 'components/grid/table';
import LogoutMenu from 'routes/admin/components/logout-menu';
import DateField from 'components/grid/table/components/fields/date-field';
import Button from 'components/button';
import { useTranslation } from 'i18n';
import { useHistory } from 'react-router';
import { WithMargin } from 'components/layout';
import { copyToClipboard } from 'utils/js';
import toast from 'services/toast';

function AdminSignInCodeList({location}) {
  const { t } = useTranslation();
  const history = useHistory();

  //console.log("XXXXX", location.search)
  
  return (
    <ListView>
      <LogoutMenu />
      <WithMargin bottom="40px">
        <Button
          label={t('Create sign in code')}
          onClick={() => history.push('/admin/sign-in-code/form')}
        />
      </WithMargin>
      <TableContainer>
        <ApiList query={signInCodesQuery} filter={{}}>
          <Table>
          {location.search === "?id" ? <Table.Field label={t('ID')} name="id" /> :  <></> }

            <Table.Field label={t('Code')} name="code" bold />
            <DateField label={t('Used on')} name="usedOn" />
            <Table.Field label={t('Email')} name="email" />
            <Table.Field
              label={t('Sign in URL')}
              name="code"
              onClick={(event, code) => {
                window.open(
                  window.location.origin + '/register?code=' + code,
                  '_blank',
                );
              }}>
              {({ data }) => {
                return window.location.origin + '/register?code=' + data.code;
              }}
            </Table.Field>
            <Table.Action
              label=" "
              icon={<CopyIcon />}
              onClick={(data) => {
                try {
                  copyToClipboard(
                    window.location.origin + '/register?code=' + data.code,
                  );
                  toast.success(t('Successfully copied to clipboard'));
                } catch (error) {
                  toast.success(t('Something went wrong'));
                }
              }}
            />
            
          </Table>
          <ApiList.Pagination />
        </ApiList>
      </TableContainer>
    </ListView>
  );
}

export default AdminSignInCodeList;
